'use strict';

angular.module('lmsApp').factory('Lesson', function ($resource) {
    return $resource('api/lessons', {}, {
        'add': {
            method: 'POST'
        },
        'update': {
            method: 'PUT',
        },
        'delete': {
            method: 'DELETE',
            url: 'api/lessons/:id'
        }
    });
});
